var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTermTypeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2.75H14L18.5 7.25V21.25H6.5C5.5335 21.25 4.75 20.4665 4.75 19.5V4.5C4.75 3.5335 5.5335 2.75 6.5 2.75Z",
    stroke: "#FCAD09",
    strokeWidth: 1.7,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.75V7.25H18.5",
    stroke: "#FCAD09",
    strokeWidth: 1.7,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11H15.75M8.25 14.5H15.75M8.25 18H13",
    stroke: "#FCAD09",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermTypeActive);
export default __webpack_public_path__ + "static/media/term_type_active.70252aab288c6a263535fe5fa1942102.svg";
export { ForwardRef as ReactComponent };